import React from 'react';
import Box from '@material-ui/core/Box';
import XMLViewer from 'react-xml-viewer';

import './MRSS.scss';

type MRSSData = {
    data: string;
};

export default function MRSS(mrssData: MRSSData) {
    const {data} = mrssData;
    
    return (
        <Box className="bg-white">
            <XMLViewer
                xml={data}
            />
        </Box>
    );
}
